module.exports = __webpack_public_path__ + "img/success-mail.3fd7c5e1.png";